<template>
    <div class="stl-month-picker">
        <button type="button" class="stl-mp-btn" title="1년 전" @click="shift(12)">«</button>
        <button type="button" class="stl-mp-btn" title="1개월 전" @click="shift(1)">‹</button>
        <DatePicker
            :value="value"
            type="month"
            format="YYYY-MM"
            value-type="format"
            :clearable="false"
            popup-class="stl-settlement-datepicker"
            class="stl-mp-dp"
            @input="$emit('input', $event)"
        />
        <button type="button" class="stl-mp-btn" title="1개월 후" @click="shift(-1)">›</button>
        <button type="button" class="stl-mp-btn" title="1년 후" @click="shift(-12)">»</button>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { shiftRegYm, ymToRegYm, regYmToYm } from "../utils/settlementFormat.js";

export default {
    name: "SettlementMonthPicker",
    components: { DatePicker },
    props: {
        value: { type: String, required: true },
    },
    methods: {
        shift(months) {
            const regYm = ymToRegYm(this.value);
            const next = shiftRegYm(regYm, -months);
            this.$emit("input", regYmToYm(next));
        },
    },
};
</script>

<style scoped>
.stl-month-picker {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    background: #fff;
    border: 1px solid #d2d8e2;
    border-radius: 8px;
    padding: 2px 4px;
    min-height: 34px;
}
.stl-mp-btn {
    width: 26px;
    height: 28px;
    border: none;
    background: transparent;
    color: #4b5363;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    line-height: 1;
}
.stl-mp-btn:hover {
    background: #f0f2f7;
}
.stl-mp-dp {
    width: 118px;
}
.stl-month-picker >>> .mx-input {
    height: 28px;
    border: none;
    box-shadow: none;
    font-family: inherit;
    font-size: 13px;
    font-weight: 600;
    padding: 0 8px;
    cursor: pointer;
}
.stl-month-picker >>> .mx-input-wrapper {
    width: 100%;
}
</style>
